/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreateSigintSignalForm = {
  /**
   * Optional classifier criteria; empty stores no value
   */
  classifierCriteria?: string | undefined;
  /**
   * Optional description; empty stores no value
   */
  description?: string | undefined;
  /**
   * Display name; trimmed before enforcing the 1 to 200 character limit
   */
  name: string;
  /**
   * A short url-friendly label that uniquely identifies a resource.
   */
  slug?: string | undefined;
};

/** @internal */
export type CreateSigintSignalForm$Outbound = {
  classifier_criteria?: string | undefined;
  description?: string | undefined;
  name: string;
  slug?: string | undefined;
};

/** @internal */
export const CreateSigintSignalForm$outboundSchema: z.ZodMiniType<
  CreateSigintSignalForm$Outbound,
  CreateSigintSignalForm
> = z.pipe(
  z.object({
    classifierCriteria: z.optional(z.string()),
    description: z.optional(z.string()),
    name: z.string(),
    slug: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      classifierCriteria: "classifier_criteria",
    });
  }),
);

export function createSigintSignalFormToJSON(
  createSigintSignalForm: CreateSigintSignalForm,
): string {
  return JSON.stringify(
    CreateSigintSignalForm$outboundSchema.parse(createSigintSignalForm),
  );
}
